if (!customElements.get('load-more')) {
  customElements.define(
    'load-more',
    class LoadMore extends HTMLElement {
      constructor() {
        super();
        this.loadMoreButton = this.querySelector('button');
        this.pageSize = this.querySelector('.page-size');
      }

      connectedCallback() {
        this.loadMoreButton.addEventListener('click', this.loadMore.bind(this));
      }

      loadMore(event) {
        event.preventDefault();
        this.loadMoreButton.setAttribute('aria-disabled', true);
        this.loadMoreButton.classList.add('loading');
        const sectionID = document.getElementById('product-grid').dataset.id;
        const url = `${this.loadMoreButton.dataset.nextProducts}&section_id=${sectionID}`;
        this.querySelector('.loading__spinner').classList.remove('hidden');
        fetch(url)
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const products = responseHTML.querySelectorAll('.product-item');
            const productGrid = document.querySelector('.product-grid');
            productGrid.append(...products);
            const productCount = document.querySelectorAll('.product-item').length;
            this.pageSize.textContent = productCount;
            this.updateButton(productCount);
          })
          .catch((error) => {
            console.error('Error fetching data: ', error);
          })
          .finally(() => {
            if (!this.loadMoreButton) return;
            this.loadMoreButton.removeAttribute('aria-disabled');
            this.loadMoreButton.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      updateButton(productCount) {
        if (productCount >= this.loadMoreButton.dataset.totalProducts) {
          this.loadMoreButton.remove();
          this.loadMoreButton = null;
        } else {
          const url = new URL(this.loadMoreButton.dataset.nextProducts, window.location.origin);
          const params = url.searchParams;
          const oldPage = params.get('page');
          params.set('page', parseInt(oldPage) + 1);
          this.loadMoreButton.dataset.nextProducts = url.pathname + url.search;
        }
      }
    }
  );
}
